import React from 'react';
import { Route, RouteProps } from 'react-router-dom';

import { NotFoundPage } from 'router/components/NotFound/NotFoundPage';

import { NavigationItem } from '../models';

type RenderRoutesProps = {
  routes: NavigationItem[];
  RelativeRoute: React.FC<RouteProps>;
  // Rendered on known routes that can't be activated, instead of falling through to
  // NotFoundPage. Unknown paths still render NotFoundPage (RPT-1568).
  inactiveRouteComponent?: React.ComponentType;
};

export const renderRoutes = ({
  RelativeRoute,
  routes,
  inactiveRouteComponent,
}: RenderRoutesProps) => {
  const filteredNavigation = inactiveRouteComponent
    ? routes
    : routes.filter((nav) => nav.canActivate);

  if (filteredNavigation.length < 1) {
    return <></>;
  }

  const result = filteredNavigation.map(({ component, path, exact, canActivate }) => {
    const Component = canActivate ? component : inactiveRouteComponent ?? component;
    return <RelativeRoute key={path.toString()} path={path} exact={exact} component={Component} />;
  });

  result.push(<Route key="not-found" component={NotFoundPage} />);

  return result;
};
